import styled from 'styled-components';

interface InputProps {
  checked: boolean;
  isUpgrade: boolean;
  disabled: boolean;
}

export const Container = styled.div<InputProps>`
  display: flex;
  font-family: Montserrat;
  flex-direction: column;
  padding: ${({ checked }) => (checked ? 'calc(2.08rem - 1px)' : '2.08rem')};
  min-height: ${({ isUpgrade }) => (isUpgrade ? '28.8rem' : '46rem')};
  border: ${({ theme: { colors }, checked, isUpgrade }) =>
    `${checked ? '0.2rem' : '0.1rem'} solid ${
      checked && !isUpgrade ? colors.b2cRedThl : colors.b2cLightGrey
    }`};
  ${({ checked }) =>
    checked && 'box-shadow: 0.2rem 0.2rem 0.4rem rgba(0, 0, 0, 0.25);'};
  border-radius: 0.2rem;
  cursor: ${({ checked, isUpgrade, disabled }) =>
    disabled ? 'not-allowed' : checked && !isUpgrade ? 'default' : 'pointer'};
  background-color: ${({ theme: { colors }, isUpgrade }) =>
    isUpgrade && colors.b2cLightRed};

  &:hover {
    box-shadow: ${({ disabled }) =>
      !disabled && `0.2rem 0.2rem 0.4rem rgba(0, 0, 0, 0.25)`}
`;

export const ArrowUp = styled.div<InputProps>`
  height: 1.223rem;
  position: relative;
  cursor: ${({ checked, isUpgrade, disabled }) =>
    disabled ? 'not-allowed' : checked && !isUpgrade ? 'default' : 'pointer'};
  &:after {
    content: '';
    position: absolute;
    width: 1.223rem;
    height: 1.223rem;
    background: ${({ theme: { colors } }) => colors.b2cLightRed};
    -webkit-transform: translateX(-50%) rotate(45deg);
    -ms-transform: translateX(-50%) rotate(45deg);
    transform: translateX(-50%) rotate(45deg);
    top: ${({ checked }) => (checked ? '0.9rem' : '0.8rem')};
    left: 50%;
    box-shadow: ${({ theme: { colors }, checked }) =>
      checked
        ? `-0.2rem -0.2rem 0 -0.02rem ${colors.b2cLightGrey}`
        : `-0.11rem -0.11rem 0 -0.02rem ${colors.b2cLightGrey}`};
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 3rem;
  margin-bottom: 1rem;
`;

export const TitleContainer = styled.div`
  width: 90%;
`;

export const Title = styled.h5`
  color: ${({ theme: { colors } }) => colors.b2cDarkBlack};
  margin-top: 0;
  margin-bottom: 0;
  font-size: 2rem;
  font-weight: 600;
  line-height: 3rem;
`;

export const DescriptionDiv = styled.div`
  font-size: 1.28rem;
`;

export const ProductCardCheckbox = styled.input<InputProps>`
  -webkit-appearance: none;
  appearance: none;
  display: flex;
  flex-shrink: 0;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 1rem;
  border: 0.1rem solid ${({ theme: { colors } }) => colors.b2cGrey};
  outline: none;
  cursor: ${({ checked, isUpgrade, disabled }) =>
    disabled ? 'not-allowed' : checked && !isUpgrade ? 'default' : 'pointer'};
  margin: 0;

  &:checked {
    border: 0.48rem solid ${({ theme: { colors } }) => colors.b2cRedThl};
    background-color: ${({ theme: { colors } }) => colors.b2cRedThl};

    &:before {
      height: 30%;
      width: 70%;
      content: '';
      border: 0.384rem solid ${({ theme: { colors } }) => colors.white};
      border-top: none;
      border-right: none;
      margin: auto;
      margin-bottom: 35%;
      -webkit-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      transform: rotate(-45deg);
      box-sizing: content-box;
    }
  }
`;

export const BottomContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
`;

export const BottomWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 4rem;
  bottom: 0px;
`;

export const ProductCardText = styled.span`
  font-weight: 400;
  font-size: 1.28rem;
  line-height: 1.8rem;
`;

export const LearnMoreButton = styled.a`
  font-size: 1.6rem;
  color: ${({ theme: { colors } }) => colors.b2cLightBlue};
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
`;

export const SelectButton = styled.a<{ disabled: boolean }>`
  font-size: 1.6rem;
  box-sizing: border-box;
  background-color: initial;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.8rem 2rem;
  width: 9.2rem;
  height: 4rem;
  background: initial;
  font-weight: 600;
  color: ${({ theme: { colors }, disabled }) =>
    !disabled ? colors.b2cRedThl : colors.b2cLightGrey};
  border: 0.1rem solid
    ${({ theme: { colors }, disabled }) =>
      !disabled ? colors.b2cRedThl : colors.b2cLightGrey};
  border-radius: 0.2rem;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin-top: auto;
  margin-bottom: auto;
  background: initial;

  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
`;
